export const WALLET_TYPE = {
	WALLET_ADJUSTMENT: 1,
	LIMIT_CHANGE: 2,
	BET: 3,
	CANCEL: 4,
	PAYOUT: 5
};
